import { ConfigProvider, Layout, Menu } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import { connect } from 'dva'
import { Link } from 'dva/router'
import React, { lazy, useEffect, useState } from 'react'
import './MainLaytout.less'
import { ReactComponent as ArchivesIcon } from '../assets/archives-1.svg'
import { ReactComponent as InitIcon } from '../assets/initiation-1.svg'
import { ReactComponent as MemberIcon } from '../assets/member-1.svg'
import { ReactComponent as TextIcon } from '../assets/text-1.svg'
import { ReactComponent as SettingsIcon } from '../assets/settings-1.svg'
import { ReactComponent as CertIcon } from '../assets/cert.svg'

const MainHeader = lazy(() => import('@/components/MainHeader'))

const { Header, Content, Sider } = Layout
const { SubMenu } = Menu

const MainLaytout = (props) => {
  const [collapsed, setCollapsed] = useState(false)
  const [selectedKeys, setSelectedKeys] = useState([])
  const [openKeys, setOpenKeys] = useState([])
  const { permissionList } = props.account
  const isAdmin = props.account.userInfo?.orgType === 0

  useEffect(() => {
    let path = location.hash.split('/')
    setSelectedKeys(path.slice(-1))
    setOpenKeys(path)
  }, [])

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed)
  }

  const onSelect = (item, key, keyPath, selectedKeys, domEvent) => {
    setSelectedKeys(item.selectedKeys)
    let path = location.hash.split('/')
    path.shift()
    setOpenKeys(path)
  }

  const onOpenChange = (openKeys) => {
    setOpenKeys(openKeys)
  }

  return (
    <Layout className="mainLayout" style={{ minHeight: '100vh' }}>
      <Header>
        <MainHeader />
      </Header>
      <Layout className="site-layout">
        <Sider className="mainSider" theme="light" collapsed={collapsed} onCollapse={onCollapse}>
          <Menu
            onSelect={onSelect}
            theme="light"
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            mode="inline"
          >
            {/* 会员统计 */}
            <SubMenu
              key="overview"
              title={
                <div className="title-container">
                  <ArchivesIcon className="icon" />
                  <span>会员统计</span>
                </div>
              }
            >
              <Menu.Item key="cockpit">
                <Link to="/overview/cockpit">会员统计</Link>
              </Menu.Item>
              <Menu.Item key="membership">
                <Link to="/overview/membership">入会统计</Link>
              </Menu.Item>
              <Menu.Item key="payment">
                <Link to="/overview/payment">缴费统计</Link>
              </Menu.Item>
            </SubMenu>

            <Menu.Item key="memberservice">
              <div className="title-container">
                <InitIcon className="icon" />
                <Link to="/memberservice">我的待办</Link>
              </div>
            </Menu.Item>

            <SubMenu
              key="enterprise"
              title={
                <div className="title-container">
                  <InitIcon className="icon" />
                  <span>单位会员</span>
                </div>
              }
            >
              <SubMenu key="entry" title="入会管理">
                <Menu.Item key="audit">
                  <Link to="/enterprise/entry/audit">资格审核</Link>
                </Menu.Item>
                <Menu.Item key="payconfirm">
                  <Link to="/enterprise/entry/payconfirm">缴费管理</Link>
                </Menu.Item>
                <Menu.Item key="certificate">
                  <Link to="/enterprise/entry/certificate">发证管理</Link>
                </Menu.Item>
              </SubMenu>
              <SubMenu key="mgmt" title="会员管理">
                <Menu.Item key="memberlist">
                  <Link to="/enterprise/mgmt/memberlist">会员管理</Link>
                </Menu.Item>
                <Menu.Item key="membertaxList">
                  <Link to="/enterprise/mgmt/membertaxList">会费管理</Link>
                </Menu.Item>
                <Menu.Item key="changeCertificate">
                  <Link to="/enterprise/mgmt/changeCertificate">换证管理</Link>
                </Menu.Item>
                <Menu.Item key="changes">
                  <Link to="/enterprise/mgmt/changes">信息变更管理</Link>
                </Menu.Item>
                <Menu.Item key="abnormal">
                  <Link to="/enterprise/mgmt/abnormal">会籍异常企业名录</Link>
                </Menu.Item>
              </SubMenu>
            </SubMenu>
            {isAdmin && (
              <SubMenu
                key="personal"
                title={
                  <div className="title-container">
                    <MemberIcon className="icon" />
                    <span>个人会员</span>
                  </div>
                }
              >
                <Menu.Item key="pending-list">
                  <Link to="/memberservice/personal/pending-list">入会复核</Link>
                </Menu.Item>
                <Menu.Item key="member-list">
                  <Link to="/member/personal/member-list">会员列表</Link>
                </Menu.Item>
              </SubMenu>
            )}

            <Menu.Item key="trainingCert">
              <div className="title-container">
                <CertIcon className="icon" />
                <Link to="/trainingCert">个人培训证书</Link>
              </div>
            </Menu.Item>

            {/* 内容管理 */}
            {permissionList.includes('CONTENT_MANAGEMENT') && (
              <SubMenu
                key="content"
                title={
                  <div className="title-container">
                    <TextIcon className="icon" />
                    <span>内容管理</span>
                  </div>
                }
              >
                <Menu.Item key="messageList">
                  <Link to="/content/message/messageList">消息管理</Link>
                </Menu.Item>
                <Menu.Item key="notice">
                  <Link to="/content/notice">公告管理</Link>
                </Menu.Item>
                <Menu.Item key="messageReply">
                  <Link to="/content/message/messageReply">反馈管理</Link>
                </Menu.Item>
              </SubMenu>
            )}

            {/* 系统管理 */}
            {permissionList.includes('SYSTEM_MANAGEMENT') && (
              <SubMenu
                key="system"
                title={
                  <div className="title-container">
                    <SettingsIcon className="icon" />
                    <span>系统管理</span>
                  </div>
                }
              >
                <Menu.Item key="org">
                  <Link to="/system/org">组织用户管理</Link>
                </Menu.Item>
                <Menu.Item key="feeConfig">
                  <Link to="/system/feeConfig">会费标准管理</Link>
                </Menu.Item>
                {/* <Menu.Item key="role">
                  <Link to="/system/role">人员角色</Link>
                </Menu.Item> */}
                {/* <Menu.Item key="userData">
                  <Link to="/system/userData">会员数据</Link>
                </Menu.Item> */}
                {/* <Menu.Item key="associateMember">
                  <Link to="/system/associateMember">准会员数据</Link>
                </Menu.Item> */}
              </SubMenu>
            )}
          </Menu>
        </Sider>
        <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
          <Content>{props.children}</Content>
        </ConfigProvider>
      </Layout>
    </Layout>
  )
}

export default connect(({ account }) => ({
  account,
}))(MainLaytout)
